// valid size is within 5MB

export const maxSize = 5e6;
export const isValidSize = (fileSize: number): boolean => {
  if (fileSize === undefined || fileSize === null) {
    return false;
  }
  return fileSize <= maxSize;
};
